import { logEvent, setCurrentScreen } from 'firebase/analytics';
import { analytics } from './firebaseConfig.js';

// Rastrear visualização de página
export const trackPageView = (path, title) => {
  try {
    setCurrentScreen(analytics, title);
    logEvent(analytics, 'page_view', {
      page_path: path,
      page_title: title
    });
  } catch (error) {
    console.error('[Analytics] Error tracking pageview:', error);
  }
};

// Rastrear eventos personalizados
export const trackEvent = (eventName, params = {}) => {
  try {
    logEvent(analytics, eventName, params);
  } catch (error) {
    console.error('[Analytics] Error tracking event:', error);
  }
};

// Eventos específicos do aplicativo
export const analyticsEvents = {
  // Autenticação
  login: (method = 'email') => {
    trackEvent('login', { method });
  },
  logout: () => {
    trackEvent('logout');
  },
  forgotPassword: () => {
    trackEvent('forgot_password');
  },
  resetPassword: () => {
    trackEvent('reset_password');
  },

  // Navegação
  navigate: (page) => {
    trackEvent('navigate', { page });
  },

  // Agendamentos
  viewSchedules: () => {
    trackEvent('view_schedules');
  },
  createSchedule: () => {
    trackEvent('create_schedule');
  },
  updateSchedule: () => {
    trackEvent('update_schedule');
  },
  cancelSchedule: () => {
    trackEvent('cancel_schedule');
  },
  confirmSchedule: () => {
    trackEvent('confirm_schedule');
  },
  
  // Configurações de agendamento
  updateScheduleSettings: () => {
    trackEvent('update_schedule_settings');
  },

  // Perfil
  viewProfile: () => {
    trackEvent('view_profile');
  },
  updateProfile: () => {
    trackEvent('update_profile');
  },
  updatePhoto: () => {
    trackEvent('update_photo');
  },

  // Avaliações
  viewReviews: () => {
    trackEvent('view_reviews');
  },
  respondReview: () => {
    trackEvent('respond_review');
  },

  // Notificações
  viewNotifications: () => {
    trackEvent('view_notifications');
  },
  markAsRead: () => {
    trackEvent('mark_notification_read');
  },

  // Entidade
  createEntity: () => {
    trackEvent('create_entity');
  },
  updateEntity: () => {
    trackEvent('update_entity');
  },

  // Assinatura
  viewSubscription: () => {
    trackEvent('view_subscription');
  },
  startCheckout: (plan) => {
    trackEvent('begin_checkout', { plan });
  },
  completeCheckout: (plan) => {
    trackEvent('purchase', { plan, currency: 'BRL' });
  },
  cancelCheckout: () => {
    trackEvent('cancel_checkout');
  },

  // Videoconferência
  startVideoCall: () => {
    trackEvent('start_video_call');
  },
  endVideoCall: (duration) => {
    trackEvent('end_video_call', { duration });
  },
  toggleCamera: (enabled) => {
    trackEvent('toggle_camera', { enabled });
  },
  toggleMicrophone: (enabled) => {
    trackEvent('toggle_microphone', { enabled });
  },

  // Chat
  sendMessage: () => {
    trackEvent('send_message');
  },
  openChat: () => {
    trackEvent('open_chat');
  },
  closeChat: () => {
    trackEvent('close_chat');
  },

  // Configurações
  updateSettings: (setting) => {
    trackEvent('update_settings', { setting });
  },

  // Erros
  error: (errorType, errorMessage) => {
    trackEvent('error', { error_type: errorType, error_message: errorMessage });
  },
};

export default analyticsEvents;
